import api from 'api'
import { ManagedAccountsByPartner } from 'hooks/useManagedAccounts'
import fetchWithToken from './fetchWithToken'

const fetchPersonableAccounts = (partnerAccountKeys: string[]): Promise<ManagedAccountsByPartner[]> =>
  fetchWithToken({
    baseUrl: api.partnerAdminUrl,
    path: `accounts/${partnerAccountKeys.join(',')}/managed-accounts`,
    useV5: false,
    useVersion: '',
    method: 'GET',
  })
    .then((response: Response) => response.json())
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })

export default fetchPersonableAccounts
